import request from '@/utils/request';

export async function sortstrategy(payload) {
  return request(`/iwms-wms/wms/sortstrategy`, {
    method: 'POST',
    body: payload,
  });
}

export async function offline(payload) {
  return request(`/iwms-wms/wms/sortstrategy/${payload.uuid}/offline`, {
    method: 'POST'
  });
}

export async function online(payload) {
  return request(`/iwms-wms/wms/sortstrategy/${payload.uuid}/online`, {
    method: 'POST'
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/sortstrategy/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function page(payload) {
  return request(`/iwms-wms/wms/sortstrategy/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/sortstrategy/${payload.uuid}`);
}

export async function remove(payload) {
  return request(`/iwms-wms/wms/sortstrategy/${payload.uuid}`, {
    method: 'DELETE'
  });
}


export async function sortcrossingpage(payload) {
  return request(`/iwms-wms/wms/sortcrossing/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function getByCode(payload) {
  return request(`/iwms-wms/wms/sortstrategy/getByCode?code=${payload.code}&dcUuid=${payload.dcUuid}`)
}

// 批量导入
export async function batchImport(payload) {
  return request(`/iwms-wms/wms/sortstrategy/batchImport?fileKey=${payload.fileKey}&schemeUuid=${payload.schemeUuid}`, {
    method: 'POST',
    body: payload,
  });
}
